import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[70vh] sm:min-h-[80vh] lg:min-h-[90vh] flex items-center pt-12 sm:pt-16 lg:pt-20 pb-10 sm:pb-16 overflow-hidden bg-noise" data-id="element-52">
      {/* Background ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] sm:w-[600px] lg:w-[800px] h-[400px] sm:h-[600px] lg:h-[800px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-53" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-54">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center" data-id="element-55">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center lg:text-left order-2 lg:order-1" data-id="element-56">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2,
            duration: 0.6
          }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-gold/30 bg-gold/5 text-gold text-xs sm:text-sm font-cinzel tracking-widest mb-4 sm:mb-6" data-id="element-57">
              <ShieldIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-58" />
              <span data-id="element-59">EL PROTOCOLO ESTOICO</span>
            </motion.div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-4 sm:mb-6 text-glow-gold" data-id="element-60">
              DEJA DE SER UN ESCLAVO DE TUS IMPULSOS Y RECLAMA TU TRONO COMO UN{' '}
              <span className="text-gold" data-id="element-61">TITÁN</span> EN 21 DÍAS.
            </h1>

            <p className="text-base sm:text-lg md:text-xl text-gray-400 mb-6 sm:mb-8 lg:mb-10 max-w-2xl mx-auto lg:mx-0 font-light leading-relaxed" data-id="element-62">
              El sistema de reconfiguración biológica y mental para hombres que
              están hartos de la procrastinación, la fatiga crónica y la
              adicción a la dopamina barata.
            </p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4,
            duration: 0.6
          }} data-id="element-63">
              <Button href="#precio" className="text-base sm:text-lg md:text-xl py-4 sm:py-5 px-6 sm:px-10 w-full sm:w-auto" data-id="element-64">
                ¡QUIERO EL PROTOCOLO Y SER UN TITÁN!
              </Button>
            </motion.div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: [1, 1.1, 1]
        }} transition={{
          opacity: {
            duration: 1,
            delay: 0.2
          },
          scale: {
            duration: 1.8,
            delay: 0.8,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} className="relative mx-auto lg:ml-auto order-1 lg:order-2" data-id="element-65">
            {/* Pulsing gold glow behind the image */}
            <motion.div animate={{
            scale: [1, 1.4, 1],
            opacity: [0.3, 0.8, 0.3]
          }} transition={{
            duration: 1.8,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] h-[90%] rounded-full bg-gold/25 blur-[50px] sm:blur-[80px] pointer-events-none z-0" data-id="element-66" />
            {/* Outer ring glow */}
            <motion.div animate={{
            scale: [1, 1.25, 1],
            opacity: [0.2, 0.5, 0.2]
          }} transition={{
            duration: 1.8,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 0.2
          }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[100%] h-[100%] rounded-full border-2 border-gold/30 blur-[20px] sm:blur-[30px] pointer-events-none z-0" data-id="element-67" />
            <div className="absolute inset-0 bg-gradient-to-t from-dark-bg via-transparent to-transparent z-10 rounded-lg" data-id="element-68" />
            <img src="https://cdn.magicpatterns.com/uploads/cEnYKCsv1x3UoCiwH9mJTT/IMG_5199.png" alt="Gladiador y León en la Arena" className="w-full max-w-[200px] sm:max-w-xs md:max-w-sm mx-auto drop-shadow-[0_0_50px_rgba(200,162,60,0.25)] relative z-[5] rounded-lg border border-gold/20" data-id="element-69" />
          </motion.div>
        </div>
      </div>

      {/* Bottom decorative line */}
      <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gold/50 to-transparent" data-id="element-70" />
    </section>;
}